import {
  mentalHealthSupportPageTitle,
  mentalHealthSupportDescription,
} from '../content/mentalHealthSupport';
import { titleWithTag, form0781HeadingTag } from '../content';

export const uiSchema = {
  'ui:title': titleWithTag(mentalHealthSupportPageTitle, form0781HeadingTag),
  'ui:description': mentalHealthSupportDescription,
};

export const schema = {
  type: 'object',
  properties: {},
};
